import { render, staticRenderFns } from "./wetter-chart.vue?vue&type=template&id=09d5d35a&"
import script from "./wetter-chart.vue?vue&type=script&lang=js&"
export * from "./wetter-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports